import {
  AdvancedCobranding,
  isAdvancedCobranding,
  isSimpleCobranding,
  SimpleCobranding,
} from '../../utilities/cobranding/cobranding';
import { CobrandingComponents } from './shared-cobranding';

import DefaultCobranding from './DefaultCobranding';
import BitbucketCobranding from './bitbucket/BitbucketCobranding';
import CompassCobranding from './compass/CompassCobranding';
import ConfluenceCobranding from './confluence/ConfluenceCobranding';
import CommunityCobranding from './community/CommunityCobranding';
import JiraCobranding from './jira/JiraCobranding';
import OpsgenieCobranding from './opsgenie/OpsgenieCobranding';
import StatuspageCobranding from './statuspage/StatuspageCobranding';
import TrelloCobranding from './trello/TrelloCobranding';
import WacCobranding from './wac/WacCobranding';
import AtlasCobranding from './atlas/AtlasCobranding';
import LoomCobranding from './loom/LoomCobranding';
import JiraAlignCobranding from './jira-align/JiraAlignCobranding';
import AdminExperimentForJira from '../../advanced-cobranding/admin/atlas-75650/jira/AdminExperimentForJira';
import AdminExperimentForConfluence from '../../advanced-cobranding/admin/atlas-75650/confluence/AdminExperimentForConfluence';
import RovoCobranding from './rovo/RovoCobranding';

const cobrandingMap: { [K in SimpleCobranding | AdvancedCobranding]: CobrandingComponents } = {
  [SimpleCobranding.ADMIN]: DefaultCobranding,
  [SimpleCobranding.ATLAS]: AtlasCobranding,
  [SimpleCobranding.BITBUCKET]: BitbucketCobranding,
  [SimpleCobranding.COMMUNITY]: CommunityCobranding,
  [SimpleCobranding.COMPASS]: CompassCobranding,
  [SimpleCobranding.CONFLUENCE]: ConfluenceCobranding,
  [SimpleCobranding.JIRA]: JiraCobranding,
  [SimpleCobranding.JIRA_ALIGN]: JiraAlignCobranding,
  [SimpleCobranding.LOOM]: LoomCobranding,
  [SimpleCobranding.NO_COBRANDING]: DefaultCobranding,
  [SimpleCobranding.OPSGENIE]: OpsgenieCobranding,
  [SimpleCobranding.PRT]: DefaultCobranding,
  [SimpleCobranding.ROVO]: RovoCobranding,
  [SimpleCobranding.SAC]: DefaultCobranding,
  [SimpleCobranding.STATUSPAGE]: StatuspageCobranding,
  [SimpleCobranding.SUPPORT]: DefaultCobranding,
  [SimpleCobranding.TRELLO]: TrelloCobranding,
  [SimpleCobranding.WAC]: WacCobranding,
  // Advanced Cobranding
  [AdvancedCobranding.ACCOUNT_LINKING]: DefaultCobranding,
  [AdvancedCobranding.ATLAS_66195]: DefaultCobranding,
  [AdvancedCobranding.CFIND_2409]: DefaultCobranding,
  [AdvancedCobranding.CONFLUENCE_ATLAS_75650]: AdminExperimentForConfluence,
  [AdvancedCobranding.DEMO]: DefaultCobranding,
  [AdvancedCobranding.ENTRY_AUTH]: DefaultCobranding,
  [AdvancedCobranding.ISOLATED_CLOUD]: DefaultCobranding,
  [AdvancedCobranding.JIRA_ATLAS_75650]: AdminExperimentForJira,
  [AdvancedCobranding.PRT_DEMO]: DefaultCobranding,
  [AdvancedCobranding.SERVICE_COLLECTION]: DefaultCobranding,
  [AdvancedCobranding.TEAMWORK_COLLECTION]: DefaultCobranding,
  [AdvancedCobranding.TWCG_1160_CONFLUENCE]: DefaultCobranding,
  [AdvancedCobranding.TWCG_1160_JIRA]: DefaultCobranding,
  [AdvancedCobranding.WAC_JPD]: DefaultCobranding,
  [AdvancedCobranding.WAC_JSM]: DefaultCobranding,
  [AdvancedCobranding.WAC_LOOM]: DefaultCobranding,
  default: DefaultCobranding,
};

export const getCobrandedComponents = (
  cobranding: SimpleCobranding | AdvancedCobranding
): CobrandingComponents => {
  if (isSimpleCobranding(cobranding) || isAdvancedCobranding(cobranding)) {
    return cobrandingMap[cobranding];
  } else {
    console.warn(
      `[COBRANDING] ${cobranding} is globally configured for advanced-cobranding but corresponding configuration for ${window.location.pathname} was not provided. Loading SimpleCobranding.NO_BRANDING as fallback.`
    );
    return cobrandingMap[SimpleCobranding.NO_COBRANDING];
  }
};
